// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"Modalforms_modal_wrapper__u9Ish","myform":"Modalforms_myform__bK7cT"};